import React, { useState, useEffect } from "react";
import { Image, Button } from "antd";
import { CheckOutlined } from "@ant-design/icons";
import { JumpApply } from "../../../../components/Jump";
import { useTranslation } from "react-i18next";
import "./index.scss";
function LifeCycle() {
  const { t } = useTranslation();
  const lifeCycleCon = t("solution_asset.asset2", {
    returnObjects: true,
  });
  return (
    <div className="lifeCycle_side" style={{}}>
      <div className="edition_solution edition_solution_top">
        <div className="edition_solution_title">
          <div>{lifeCycleCon.title}</div>
          <span>{lifeCycleCon.detail}</span>
        </div>
      </div>
      <div className="lifeCycle_con">
        <div className="lifeCycle_left">
          <div className="lifeCycle_til">{lifeCycleCon.content.title}</div>
          <div className="lifeCycle_ul">
            {lifeCycleCon.content.list.map((item, index) => (
              <div className="lifeCycle_li" key={index}>
                <div className="lifeCycle_li_til">
                  <div className="lifeCycle_li_icon">
                    <img
                      src={
                        require("../../../../assets/images/solution/infoServices/icon.png")
                          .default
                      }
                    />
                  </div>
                  {item.title}
                </div>
                <div className="lifeCycle_li_det">{item.detail}</div>
              </div>
            ))}
          </div>
        </div>
        <div className="lifeCycle_right">
          <img src={lifeCycleCon.content.imgUrl} alt="" />
          <div className="lifeCycle_right_detail">
            {lifeCycleCon.content.detail}
          </div>
        </div>
      </div>
    </div>
  );
}

export default LifeCycle;
